<template>
  <div class="dialog-wrapper">
    <div class="dialog-wrapper__popup">
      <div class="guide">
        <h1 v-if="username" :class="{ 'text-small': username.length > 7 }">{{ username }}</h1>
        <p>본인의 성함을 정자로 서명해주세요.</p>
      </div>
      <VueSignaturePad class="pad" ref="signaturePad" />
      <button v-ripple @click="$emit('close')" class="cancel-btn" type="button">취소</button>
      <button v-ripple @click="ok" class="confirm-btn" type="submit">확인</button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    username: {
      type: String,
      default: null
    }
  },
  created() {
    this.$store.commit('ui/modalVisible', true)
  },
  destroyed() {
    this.$store.commit('ui/modalVisible', false)
  },
  methods: {
    ok() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty === true) {
        alert('사인을 해주세요.')
      } else {
        this.$emit('sign-success', data)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 42.5rem;
  height: 100%;
  margin: 0;
  z-index: 999;

  &__popup {
    text-align: center;
    width: calc(100% - 100px);
    max-width: 350px;
    margin: 0 auto;
    position: relative;
    background-color: #ffffff;
    margin-top: 4rem;
    padding: 30px 25px;
    height: 16rem;
    border-radius: 10.7px;
    animation: modal-popup-show 0.3s;
    .guide {
      z-index: 1;
      width: calc(100% - 50px);
      position: absolute;
      height: 9rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-end;
      p, h1 {
        text-align: center;
        color: #8a94a2;
        font-size: 18px;

        -ms-user-select: none;
        -moz-user-select: -moz-none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      }

      p {
        font-size: 14px;
        word-break: keep-all;
        font-weight: 700;
      }

      h1 {
        font-size: 30px;
        letter-spacing: 20px;
        text-indent: 20px;
        width: 100%;
        text-align: center;

        &.text-small {
          font-size: 20px;
        }
      }
    }
    .pad {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 2;

      -ms-user-select: none;
      -moz-user-select: -moz-none;
      -khtml-user-select: none;
      -webkit-user-select: none;
      user-select: none;
    }
    button {
      outline: none;
      font-size: 20px;
      font-weight: 800;
      margin: 0;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      position: absolute;
      bottom: 0;
      z-index: 3;
    }
    .cancel-btn {
      color: rgb(114, 125, 140);
      background-color: rgb(215, 225, 234);
      left: 0;
      width: 38.5%;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 10.7px;
    }
    .confirm-btn {
      color: #ffffff;
      background-color: rgb(51, 51, 51);
      right: 0;
      width: 61.5%;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 10.7px;
    }
  }
}
@keyframes modal-popup-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
